/** The mixed Worklist layout; the Prior Auth and Intake views use those tabs' own columns. */
export const WORKLIST_COLUMNS = [
    { key: "patientName", label: "Patient", width: "190px", sticky: true, pinned: true },
    { key: "type", label: "Type", width: "110px" },
    { key: "status", label: "Status", width: "210px" },
    { key: "assignees", label: "Assigned", width: "165px" },
    { key: "groups", label: "Groups", width: "170px", defaultHidden: true },
    { key: "tags", label: "Tags", width: "180px" },
    { key: "substatusTags", label: "Substatus", width: "220px", mobileRole: "tags" },
    { key: "medication", label: "Medication", width: "220px" },
    { key: "payer", label: "Insurance", width: "150px" },
    { key: "provider", label: "Provider", width: "150px", defaultHidden: true },
    { key: "mrn", label: "Patient ID (MRN)", width: "120px", mono: true },
    { key: "expiresOn", label: "Expires", width: "150px", defaultHidden: true },
    { key: "documentTypes", label: "Doc Type", width: "150px", defaultHidden: true },
    { key: "sentBy", label: "Sent By", width: "130px", defaultHidden: true },
    { key: "priorAuthNumber", label: "PA Number", width: "130px", mono: true, defaultHidden: true },
    { key: "prescriptionNumber", label: "Rx Number", width: "130px", mono: true, defaultHidden: true },
    { key: "createdOn", label: "Created", width: "140px", mono: true, datetime: true },
    { key: "lastActivityAt", label: "Last Activity", width: "140px", mono: true, datetime: true, defaultHidden: true },
    { key: "dateModified", label: "Last Modified", width: "140px", mono: true, datetime: true, defaultHidden: true },
    { key: "modifiedBy", label: "Modified By", width: "130px", defaultHidden: true },
    { key: "actions", label: "", width: "48px", fixed: true },
];
/** The Worklist sort behind each column key the PA, Intake and Worklist layouts use. */
export const SORT_KEY_FOR_COLUMN = {
    patientName: "patient",
    status: "status",
    medication: "medication",
    insurance: "payer",
    payer: "payer",
    provider: "provider",
    mrn: "mrn",
    expiresOn: "expires",
    createdOn: "created",
    dateCreated: "created",
    dateReceived: "created",
    dateModified: "modified",
    lastActivityAt: "updated",
    modifiedBy: "modified_by",
    tags: "tag_due",
    substatusTags: "substatus",
};
